import { Button } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'

import { AnalyticsEventData } from '../../api/types'
import facebookLogo from '../../public/facebook.svg'
import googleLogo from '../../public/google.svg'
import styles from './social-button.module.scss'

export type SocialProvider = 'google' | 'facebook'
interface SocialButtonProps {
  provider: SocialProvider
  appId?: string
  featureCode?: string
  fromComponent?: string
  nextUrl?: string
  eventData?: AnalyticsEventData
  children: React.ReactNode
}

export function SocialButton({ provider, children }: SocialButtonProps) {
  return (
    <div className={styles.socialButton}>
      <Button
        kind="tertiary"
        size="md"
        className={styles.button}
        leftIcon={
          <Image
            src={provider === 'google' ? googleLogo : facebookLogo}
            alt={`${provider} logo`}
            width={20}
            height={20}
            className={styles.socialLogo}
            unoptimized
          />
        }
      >
        {children}
      </Button>
    </div>
  )
}
